import { useSelector } from 'react-redux'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { CategoryInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import { selectClusterImageUrl } from '../../../../../store/slices/currentClusterSlice'
import copy from '../../../../../assets/images/icons/copy.svg'

type Props = {
  startEdit: (el: CategoryInterface) => void
  el: CategoryInterface
  showDetails: (el: CategoryInterface) => void
  startDuplicate: (el: CategoryInterface) => void
}

export const Item = ({ startEdit, el, showDetails, startDuplicate }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  const imageUrl = useSelector(selectClusterImageUrl)

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        <img className={classes.image} src={`${imageUrl + el.files[0]}`} alt={el.name} />
        <div className={classes.filesLengthAnchor}>
          <div className={classes.filesLength}>{el.files.length}</div>
        </div>
        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.description, 100)}</div>
        </div>
        {<div className={classes.sort}>{el.sortOrder !== 0 ? el.sortOrder : ''}</div>}
      </div>
      <div className={classes.buttons}>
        <IconButton
          display
          onClick={() => {
            showDetails(el)
          }}
          icon={search}
          alt="Детали"
          small
        />
        <IconButton
          display
          onClick={() => {
            startDuplicate(el)
          }}
          icon={copy}
          alt="Добавить вариант"
          small
        />
        <IconButton
          display
          onClick={() => {
            startEdit(el)
          }}
          icon={edit}
          alt="Изменить"
          small
        />
      </div>
    </div>
  )
}
